import { useNavigationTableSort } from "components/scrapEyeDataDashboard/navigation/useNavigationTableSort";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { SortableHeaderCell } from "components/common/SortableHeaderCell";
import { useTenantTranslation } from "hooks/formatters";
import { SortValueGetters } from "hooks/useTableSort";
import { RedactFootagePreviewItem } from "src/store/api/generatedApi";

type RedactionPreviewTableProps = Readonly<{
  items: RedactFootagePreviewItem[];
  totalSegments: number;
}>;

type RedactionPreviewColumn =
  "deviceName" | "cameraPhysicalId" | "segmentCount";

const redactionPreviewSortValueGetters: SortValueGetters<
  RedactFootagePreviewItem,
  RedactionPreviewColumn
> = {
  deviceName: (item) => item.device_name,
  cameraPhysicalId: (item) => item.camera_physical_id,
  segmentCount: (item) => item.segment_count,
};

export const RedactionPreviewTable = ({
  items,
  totalSegments,
}: RedactionPreviewTableProps) => {
  const { t } = useTenantTranslation();
  const { sortedRows, sort, toggleSort } = useNavigationTableSort({
    key: "redactionOrder",
    rows: items,
    sortValueGetters: redactionPreviewSortValueGetters,
    initialSort: null,
  });

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <SortableHeaderCell
              column="deviceName"
              sort={sort}
              onSort={toggleSort}
              sx={{ fontWeight: "fontWeightBold" }}
            >
              {t("installationDeviceLabel")}
            </SortableHeaderCell>
            <SortableHeaderCell
              column="cameraPhysicalId"
              sort={sort}
              onSort={toggleSort}
              sx={{ fontWeight: "fontWeightBold" }}
            >
              {t("installationCameraPhysicalIdLabel")}
            </SortableHeaderCell>
            <SortableHeaderCell
              column="segmentCount"
              sort={sort}
              onSort={toggleSort}
              sx={{ fontWeight: "fontWeightBold" }}
              align="right"
            >
              {t("segmentCount")}
            </SortableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((item) => (
            <TableRow
              key={`${item.device_id}-${item.camera_physical_id}`}
              hover
            >
              <TableCell>{item.device_name}</TableCell>
              <TableCell>{item.camera_physical_id}</TableCell>
              <TableCell align="right">{item.segment_count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {t("redactFootageWarning", { count: totalSegments })}
      </Typography>
    </>
  );
};
